import { SectionVerticalSlide } from "@/components";
import { useGetCommon, type MainInfoResponse } from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { AboutSection, Location } from "../common";
import { CTASection } from "../common/components/ctaSection";

export const About = () => {
    const { data } = useGetCommon<MainInfoResponse>({ section: "main" });
    return data ? (
        <SectionVerticalSlide>
            <AboutSection />
            <Location />
            <CTASection imgList={data.imgList} />
        </SectionVerticalSlide>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
